import * as React from 'react'

import { Card } from '@enechain/eposition-ui'

type Props = {
  children: React.ReactNode
}

const filterContent: React.FC<Props> = ({ children }) => {
  return (
    <Card
      borderColor="transparent"
      backgroundColor="Surface.secondary"
      bodyProps={{
        padding: '4',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Card>
  )
}

export const FilterContent = React.memo(filterContent)
